import type { ApiResponse } from '@asetquhub/validation';
import { api } from '../lib/axios';

interface PrivyRegistrationResult {
  registrationUrl: string;
  status: string;
}

interface PrivyStatusResult {
  status: string;
  identity?: {
    name?: string;
    phone?: string;
    email?: string;
    nik?: string;
  };
  reason?: string;
}

class PrivyService {
  /**
   * Start Privy registration - returns registration URL for iframe
   */
  async startRegistration(): Promise<PrivyRegistrationResult> {
    const response = await api.post<ApiResponse<PrivyRegistrationResult>>('/api/privy/register');
    if (!response.data.data) {
      throw new Error('Failed to start registration');
    }
    return response.data.data;
  }

  /**
   * Check current registration status
   */
  async checkStatus(): Promise<PrivyStatusResult> {
    const response = await api.post<ApiResponse<PrivyStatusResult>>('/api/privy/status');
    if (!response.data.data) {
      throw new Error('Failed to check status');
    }
    return response.data.data;
  }

  /**
   * Resend registration for soft-reject retry
   */
  async resend(): Promise<PrivyRegistrationResult> {
    const response = await api.post<ApiResponse<PrivyRegistrationResult>>('/api/privy/resend');
    if (!response.data.data) {
      throw new Error('Failed to resend registration');
    }
    return response.data.data;
  }

  /**
   * Restart registration with a fresh reference_number (OTP limit hit)
   */
  async restart(): Promise<PrivyRegistrationResult> {
    const response = await api.post<ApiResponse<PrivyRegistrationResult>>('/api/privy/restart');
    if (!response.data.data) {
      throw new Error('Failed to restart registration');
    }
    return response.data.data;
  }
}

export const privyService = new PrivyService();
